/*!

=========================================================
* Argon Dashboard PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";

// reactstrap components
import { NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";

class Login extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        <footer className={`py-5 ${(this.props.location.pathname.indexOf('admin/detail') > 0 ? 'mb-5' : 'mb-0')}`} id="footer-main">
          <Container>
            <Row className="align-items-center justify-content-xl-between">
              <Col xl="6">
                <div className={`copyright text-center text-xl-left text-muted text-sm`}>
                  © {new Date().getFullYear()}{" "}
                  <a
                    className="font-weight-bold text-muted ml-2"
                    href="https://www.dpgmedia.nl?ref=rsstool"
                    target="_blank"
                  >
                    DPG Media
                  </a>
                </div>
              </Col>
              <Col xl="6">
                <Nav className="nav-footer justify-content-center justify-content-xl-end">
                  <NavItem>
                    <NavLink
                      href="https://www.dpgmedia.nl/privacy"
                      target="_blank"
                      className="text-muted"
                    >
                      Privacy verklaring
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="https://www.dpgmedia.nl/app/uploads/2019/11/Algemene-Voorwaarden_DPG-Media-B.V._versie-1-januari-2020.pdf"
                      target="_blank"
                      className="text-muted"
                    >
                      Algemene voorwaarden
                    </NavLink>
                  </NavItem>  
                </Nav>
              </Col>
            </Row>
          </Container>
        </footer>
      </>
    );
  }
}

export default Login;
